<template>
  <div>
    <PageHeader>
      <el-tabs v-model="activeTabName">
        <el-tab-pane :label="$t('Common.web')" name="first" v-if="webRole"> </el-tab-pane>
        <el-tab-pane :label="$t('Common.app')" name="second" v-if="wapRole"> </el-tab-pane>
      </el-tabs>
    </PageHeader>
    <LogWeb v-if="webRole && activeTabName === 'first'" :role="webRoleChildList" />
    <LogWap v-if="wapRole && activeTabName === 'second'" :role="wapRoleChildList" />
  </div>
</template>

<script>
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'

import LogWeb from './LogWeb'
import LogWap from './LogWap'
export default {
  mixins: [getRoleFromPath],
  components: {
    LogWeb,
    LogWap
  },
  data() {
    return {
      activeTabName: ''
    }
  },
  computed: {
    roleChildList() {
      const role = this.role.operationCode === 'log' && this.role.isPermission === 'Y'
      return role ? this.role.childList : []
    },
    // Web端
    webRole() {
      let webRole = getRoleByOperationCode(this.roleChildList, 'log_web')
      if (webRole) {
        let val = getRoleByOperationCode(webRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    webRoleChildList() {
      let webRole = getRoleByOperationCode(this.roleChildList, 'log_web')
      return webRole ? webRole.childList : []
    },
    // 移动端
    wapRole() {
      let wapRole = getRoleByOperationCode(this.roleChildList, 'log_wap')
      if (wapRole) {
        let val = getRoleByOperationCode(wapRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    wapRoleChildList() {
      let wapRole = getRoleByOperationCode(this.roleChildList, 'log_wap')
      return wapRole ? wapRole.childList : []
    }
  },
  watch: {
    webRole: {
      handler(val) {
        if (val) {
          this.activeTabName = 'first'
        }
      },
      immediate: true
    },
    wapRole: {
      handler(val) {
        if (!this.webRole && val) {
          this.activeTabName = 'second'
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin-left: 64px;
  float: left;
  /deep/.el-tabs__header {
    margin-bottom: 0;
  }
}
</style>
